// src/components/leads/pipelineStage.ts
/** Inbox column for leads that have not been given a real stage yet. Not a configurable stage. */

export const NEW_LEAD_STAGE_ID = '__new_lead__';

const UNASSIGNED = new Set(['', 'new', 'new lead', 'no action yet']);

export function isUnassignedStage(stage: string | null | undefined): boolean {
  return UNASSIGNED.has((stage || '').trim().toLowerCase());
}

/** Soft gray — no stage yet. See-through so it doesn’t look like a real stage. */
export const NEW_LEAD_DOT_STYLE: React.CSSProperties = {
  background: 'rgba(156, 163, 175, 0.32)',
  boxShadow: 'none',
};

export const NEW_LEAD_PILL_STYLE: React.CSSProperties = {
  background: 'rgba(156, 163, 175, 0.22)',
  color: 'rgba(255, 255, 255, 0.82)',
  border: '1px solid rgba(255, 255, 255, 0.16)',
  boxShadow: 'none',
};
